const Section4Partner = () => {
  return (
    <section  className="text-size"
    style={{backgroundColor:"black",  paddingTop: "2em", paddingBottom: "2em" }}>
      <div>
        <div>
          <img
          className="section4-image"
            src="https://web-summit-library.imgix.net/collision/2019/06/BMO-stand-during-day-one-of-Collision-2019-at-Enercare-Center-in-Toronto.jpg?auto=compress%2Cformat&ixlib=php-3.3.0&s=5f677d1753bae0adb1a12e7b7cbc4306"
            alt="carmelo-anthony_nba-all-star-entrepreneur_centre-stage-2022"
            loading="eager"
          />
        </div>
        <div style={{ display: "inline-flex" }}>
          <div
            style={{ padding: "2em", width: "50%", backgroundColor: "black" }}
          >
            <div style={{ color: "white" }}>
              <div style={{ marginBottom: "2em" }}>
                <span style={{ color: "white" }}>
                  "We had many high quality conversations that will generate
                  collaborations…{" "}
                </span>
              </div>
              Wolfram Research{" "}
            </div>
          </div>

          <div>
            <img
              style={{ width: "100%", height: "250px" }}
              src="
                https://web-summit-library.imgix.net/collision/2019/06/Magic-Leap-Booth-during-day-three-of-Collision-2019-at-Enercare-Center-in-Toronto.jpg?auto=compress%2Cformat&ixlib=php-3.3.0&s=ee02cf9347f46c25fb99e074fd231163"
              alt="carmelo-anthony_nba-all-star-entrepreneur_centre-stage-2022"
              loading="eager"
            />
          </div>


        </div>
        <div style={{ display: "inline-flex" }}>
          <div
            style={{ padding: "2em", width: "50%", backgroundColor: "black" }}
          >
            <div style={{ color: "white" }}>
              <div style={{ marginBottom: "2em" }}>
                <span style={{ color: "white" }}>
                  "At Collision, you’ll have the opportunity to put your company
                  centre stage in… ”
                </span>
              </div>
              DigitalOcean
            </div>
          </div>

          <div
            style={{ padding: "1em", width: "50%", backgroundColor: "black" }}
          >
            <div style={{ color: "white" }}>
              <div style={{ marginBottom: "2em" }}>
                <span style={{ color: "white" }}>
                  "North America's fastest-growing tech conference."
                </span>
              </div>
              Forbes{" "}
            </div>
          </div>
          

        </div>
        <div>
          <img
          className="section4-image"
          src="https://web-summit-library.imgix.net/collision/2019/05/46980140175_b3fd9f93eb_k.jpg?auto=compress%2Cformat&ixlib=php-3.3.0&s=0fb6e9363dda23fea0dc9afca82a1fb1
              "
            alt="carmelo-anthony_nba-all-star-entrepreneur_centre-stage-2022"
            loading="eager"
          />
        </div>
      </div>
    </section>
  );
};

export default Section4Partner;
